export { default } from './InformationCircle'
